import React from 'react';

interface FinalCtaSectionProps {
  email: string;
  isSubmitting: boolean;
  error: string;
  onEmailChange: (value: string) => void;
  onSubmit: (event: React.FormEvent) => void;
}

const FinalCtaSection: React.FC<FinalCtaSectionProps> = ({
  email,
  isSubmitting,
  error,
  onEmailChange,
  onSubmit
}) => {
  return (
    <section className="relative overflow-hidden mt-6">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(11,31,62,0.42) 0%, rgba(22,52,100,0.34) 70%, rgba(10,28,58,0.44) 100%), linear-gradient(0deg, rgba(10,31,70,0.38), rgba(10,31,70,0.38)), url('/images/miningreporthero.webp')",
          backgroundSize: 'cover, cover, cover',
          backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
          backgroundPosition: 'center 72%, center 72%, center 72%'
        }}
      />

      <div className="relative max-w-[900px] mx-auto px-6 py-12 text-center text-white">
        <h3 className="text-[25px] md:text-[30px] font-[700] leading-[1.2] tracking-[0.02em]">
        Claim Your Free Copy Before This Offer Closes
        </h3>
        <p className="mt-2 text-[25px] md:text-[30px] font-[700] leading-[1.2] tracking-[0.02em]">
          Enter your email below to instantly receive:
        </p>
        <p className="mt-5 text-[18px] md:text-[20px] tracking-[0.01em] font-[500]">“Mining Super-Cycle: 2025 Recap & 2026 Strategic Outlook”</p>
        <p className="mt-7 text-[18px] md:text-[20px] text-white font-[400]">No cost. No catch. No gatekeeping.</p>
        <p className="mt-7 text-[18px] md:text-[20px] text-white font-[400] max-w-[720px] mx-auto">
        Just high-conviction analysis from 25 years in the trenches — the same edge that helped turn a $5M junior into a $2B+ winner.
        </p>

        <form onSubmit={onSubmit} className="mt-20">
          <input
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            type="email"
            placeholder="yourbest@email.com"
            className="w-full max-w-[460px] h-[52px] px-5 rounded-full text-center text-[18px] text-[#111827] focus:outline-none focus:ring-2 focus:ring-[#D3A12A]"
            required
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="block mt-4 w-full max-w-[560px] mx-auto h-[48px] md:h-[52px] rounded-[8px] bg-[#D3A12A] text-white font-[700] text-[16px] sm:text-[18px] md:text-[22px] leading-none px-4 hover:bg-[#ae8a2a] disabled:bg-gray-400"
          >
            {isSubmitting ? 'Submitting...' : 'Grab The Full Report Now'}
          </button>
        </form>

        {error && <p className="mt-3 text-[14px] text-red-300">{error}</p>}

        <p className="mt-6 text-[15px] text-white font-[400]">We hate spam as much as you do.</p>
        <p className="mt-1 text-[15px] text-white font-[400]">
          Privacy protected. Instant delivery. One-click <span className="text-[#0984FF]">unsubscribe</span>.
        </p>
        <p className="mt-6 text-[15px] text-white font-[400]">This is one of those rare windows where macro forces, capital flows, and undervalued assets line up perfectly.
          The Wealthy Miner community is already positioned. Don’t watch from the sidelines.
          thewealthyminer.com | Robert Bruggeman, CFA</p>
      </div>
    </section>
  );
};

export default FinalCtaSection;
